<template>
  <div class="detail-books ebook-lesson bg-color-light">
		<div class="detail-books__head display-flex-center justify-content-between">
			<a
        href="javascript:;"
        class="ebook-lesson__back secondary-color-txt font-size-15 font-family-Semibold"
        @click="backReadBook"
      >
				<span class="icon-arrow-left secondary-color-txt"><span class="path1"></span><span class="path2"></span></span> Trở lại
			</a>
			<h3 class="font-size-15 secondary-color-txt font-sanpro-semibold margin-0 text-center">{{ lessonBookViewing[indexLessonActive].title }}</h3>
			<div class="btn-function">
        <a href="javascript:;" class="item" @click="handleViewInfo(lessonBookViewing[indexLessonActive])">
          <i class="icon-info" />
        </a>
      </div>
		</div>
		<div class="detail-books__body position-rel">
			<div class="detail-books__body__wrap">
				<div
          class="detail-books__tabs tabs-center effect-transition-fast"
        >
          <div
            v-if="tabActive === 0 && lessonBookViewing[indexLessonActive] && lessonBookViewing[indexLessonActive].lessonPlan && lessonBookViewing[indexLessonActive].lessonPlan.fileName"
            id="script_docs_pptx"
            class="detail-books__tabs__body lib-lesson__tabs__body full-box display-flex-center"
            :class="{'is-zoom': isZoomFile}"
          >
            <div id="lesson_img" class="lib-lesson__imgs lib-lesson__imgs--pptx effect-transition-fast display-flex">
              <div id="lesson_img_wrap" class="lib-lesson__imgs__wrap display-flex">
                <div
                  v-for="num in pageSettingLessonPlan.pageLoaded"
                  :key="num"
                  class="item text-center effect-transition-fast custom-scroll"
                  :class="{'zoom-in': scale > 1}"
                  :style="`width: ${sizeBoxSlide.width}px; padding: ${openLessonCats ? '0 20px' : ''}`"
                >
                  <img
                    class="item__img effect-transition-fast"
                    :id="`item_${num}`"
                    :style="styleZoom"
                    :src="`${imgCdnUrl}${lessonBookViewing[indexLessonActive].lessonPlan.fileName}-${num}.jpg`"
                    :alt="lessonBookViewing[indexLessonActive].lessonPlan.pathView"
                  />
                </div>
              </div>
            </div>
          </div>
          <vue-custom-scrollbar
            v-else-if="tabActive === 1 && lessonBookViewing[indexLessonActive] && lessonBookViewing[indexLessonActive].script && lessonBookViewing[indexLessonActive].script.fileName"
            id="script_docs"
            class="detail-books__tabs__body"
            @ps-scroll-y="handleScrollScript"
          >
            <div id="lesson_img_script" class="lib-lesson__imgs lib-lesson__imgs--script effect-transition-fast display-flex">
              <div id="lesson_img_script_wrap" class="lib-lesson__imgs__wrap" v-if="lessonBookViewing[indexLessonActive].script">
                <div :id="`item_script_${num}`" class="item item-script text-center effect-transition-fast" v-for="num in pageSettingScript.pageLoaded" :key="num" :style="`width: ${sizeBoxSlide.width}px`">
                  <!-- :style="`width: ${sizeBoxSlide.width}px`" -->
                  <img
                    class="item__img"
                    :style="styleZoom"
                    :src="`${imgCdnUrl}${lessonBookViewing[indexLessonActive].script.fileName}-${num}.jpg`"
                    :alt="lessonBookViewing[indexLessonActive].script.pathView"
                  />
                </div>
              </div>
              <p v-else class="font-size-22 text-center secondary-color-txt full-width">Đang cập nhật dữ liệu</p>
            </div>
          </vue-custom-scrollbar>
				</div>
			</div>
      <EbookLessonSidebar
        :pageSettingLessonPlan="pageSettingLessonPlan"
        :pageSettingScript="pageSettingScript"
        :class="{'active': openLessonCats}"
        @directPage="directPage"
        @changeTypeLesson="changeTab"
      />
		</div>
		<div class="detail-books__footer lib-detail__footer color_bg_gray_light display-flex-center justify-content-between position-rel full-width">
			<a 
				href="javascript:;" 
				class="primary-color font-size-16 font-sanpro-semibold book-viewer__footer__cats border-rd-20 position-rel display-flex-center justify-content-center"
				@click="handleToggleLessonCats"
				:class="{'btn-2': openLessonCats}"
			>
				<img src="@/assets/imgs/icon-list.png" class="icon-list" alt="Danh sách bài giảng">
				<span class="only-pc">Danh sách</span>
			</a>
			<div class="book-viewer__paging display-flex-center">
				<button class="prev-page" @click="prevPage">
					<i class="icon-prev primary-color"></i>
				</button>
				<div class="book-viewer__paging__input">
					<span class="text-center" v-if="lessonBookViewing[indexLessonActive] && (lessonBookViewing[indexLessonActive].lessonPlan || lessonBookViewing[indexLessonActive].script)">
						{{ tabActive === 0 ? pageSettingLessonPlan.page : pageSettingScript.page }} / {{ tabActive === 0 && lessonBookViewing[indexLessonActive].lessonPlan ? lessonBookViewing[indexLessonActive].lessonPlan.totalPage : lessonBookViewing[indexLessonActive].script ? lessonBookViewing[indexLessonActive].script.totalPage : 0 }}
					</span>
				</div>
				<button class="next-page" @click="nextPage">
					<i class="icon-next primary-color"></i>
				</button>
			</div>
			<div class="book-viewer__zoom-switch display-flex-center">
				<div class="book-viewer__zoom">
					<button class="zoom-out" @click="handleZoom(null, '-')">
						<i class="icon-minus font-size-14 secondary-color-txt"></i>
					</button>
					<span class="ratio-book">{{ formattedZoom }} %</span>
					<button class="zoom-in" @click="handleZoom(null, '+')">
						<i class="icon-plus font-size-14 secondary-color-txt"></i>
					</button>
				</div>
        <div class="detail-books__actions display-flex-center">
          <a href="javascript:;" class="item" @click="handleShareLesson">
            <i class="icon-share-2" />
          </a>
          <a href="javascript:;" class="item" @click="handleDownload">
            <i class="icon-download" />
          </a>
        </div>
			</div>
		</div>
    <ModalShare />
    <EbookLessonInfo :dataSource="lessonInfo" />
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY, ID_MODAL_EBOOK_LESSON_INFO } from './../../_store/constants'
import { TAB_LESSON } from '@/modules/libraries/_store/constants'
import { getLessonInfo } from './../../_api/'
import { APP_CONFIG } from '@/utils/constants'
import { scrollTo } from '@/helpers/functions'
import mixinsFiles from '@/components/content-files/mixinsFiles'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ModalShare from '@/modules/libraries/_components/detail/ModalShare.vue'
import EbookLessonInfo from './EbookLessonInfo.vue'
import EbookLessonSidebar from './EbookLessonSidebar.vue'
import { FLE_DOWNLOAD_BEFORE } from '@/store/common/constants'
const img404 = require(`@/assets/images/img_404.jpg`)

export default {
  name: 'EbookLesson',
  mixins: [ mixinsFiles ],
  components: {
    vueCustomScrollbar,
    ModalShare,
    EbookLessonInfo,
    EbookLessonSidebar
  },
  data () {
    return {
      img404,
      imgCdnUrl: APP_CONFIG.bookImgCdnUrl,
      apiUrl: APP_CONFIG.appUrl,
      pageLoading: 3,
      scale: 1,
      slideTranslateX: 0,
      sizeBoxSlide: {
        width: 0,
        height: 0
      },
      tabLesson: TAB_LESSON,
      openLessonCats: false,
      tabActive: 0,
      pageSettingLessonPlan: {
        page: 0,
        pageLoaded: 0
      },
      pageSettingScript: {
        page: 0,
        pageLoaded: 0
      },
      scrollPosition: 0,
      lastPageOffsetTop: 0,
      settingsViewBookSidebar: {
        maxScrollbarLength: 300
      },
      isZoomFile: false,
      styleZoom: {width: ''},
      idBookLessonPlanFile : 0,
      lessonInfo: {},
      widthImgRenderDefault: 0
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['lessonBookViewing']),
    formattedZoom () {
      return Number.parseInt(this.scale * 100)
    },
    indexLessonActive () {
      return (parseInt(this.$route.query.lesson) - 1)
    }
  },
  mounted () {
    this.initLesson()
    this.setSizeForSlide()
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetLessonBookViewing']),
    ...mapActions('common', ['setLoading', 'acToggleModalShareMedia', 'acSetMediaShareInfo']),

    initLesson () {
      if(this.tabActive === 0 && this.lessonBookViewing[this.indexLessonActive].lessonPlan && this.lessonBookViewing[this.indexLessonActive].lessonPlan.totalPage > 0) {
        this.pageSettingLessonPlan.page = 1;
        this.pageSettingLessonPlan.pageLoaded = this.pageLoading;
      } else if (this.tabActive === 1 && this.lessonBookViewing[this.indexLessonActive].script && this.lessonBookViewing[this.indexLessonActive].script.totalPage > 0) {
        // console.log('Tab pageSettingScript')
        this.pageSettingScript.page = 1;
        this.pageSettingScript.pageLoaded = this.pageLoading;
      }
    },

    backReadBook () {
      this.acSetLessonBookViewing(null)
      this.$router.replace({ query: null })
    },

    setSizeForSlide () {
      setTimeout(() => {
        if (document.getElementById(`lesson_img`)) {
          this.sizeBoxSlide.width = document.getElementById(`lesson_img`).clientWidth
          this.sizeBoxSlide.height = document.getElementById(`lesson_img`).clientHeight
          // Get width img first list
          this.setWidthImgAfterRender()
        }
        // open sidebar slide
        this.handleToggleLessonCats()
        // this.openSidebar(DETAIL_TAB_INFO);
      }, 500)
    },

    nextPage() {
      if(this.tabActive === 0 && this.lessonBookViewing[this.indexLessonActive].lessonPlan) {
        if( this.pageSettingLessonPlan.pageLoaded < this.lessonBookViewing[this.indexLessonActive].lessonPlan.totalPage ) {
          this.pageSettingLessonPlan.pageLoaded +=1;
        }

        if(this.pageSettingLessonPlan.page < this.lessonBookViewing[this.indexLessonActive].lessonPlan.totalPage) {
          this.pageSettingLessonPlan.page +=1;
          // Await render dom
          this.setSlideAction()
        }
      } else if(this.lessonBookViewing[this.indexLessonActive].script) {
        this.pageSettingLessonPlan.page < this.lessonBookViewing[this.indexLessonActive].lessonPlan.totalPage && this.setScrollToPage(this.pageSettingLessonPlan.page + 1);
      }
    },

    prevPage() {
      if(this.tabActive === 0) {
        if(this.pageSettingLessonPlan.page > 1) {
          this.pageSettingLessonPlan.page -= 1;
          this.setSlideAction('-')
        }
      } else if(this.lessonBookViewing[this.indexLessonActive].script) {
        this.pageSettingLessonPlan.page > 1 && this.setScrollToPage(this.pageSettingLessonPlan.page - 1);
      }
    },

    setSlideAction(type = '+', betweenPageCurr = 0) {
      let elementActive = document.getElementById(`lesson_img`)
      let elementSlideSwrap = document.getElementById(`lesson_img_wrap`)
      if(elementActive) {
        let widthElm = elementActive.clientWidth
        // Support for direct page form input or click pageindex
        if(betweenPageCurr > 0) {
          widthElm *=betweenPageCurr
        }
        this.slideTranslateX = type === '+' ? this.slideTranslateX - widthElm : this.slideTranslateX + widthElm
        elementSlideSwrap.style.transform = `translateX(${this.slideTranslateX}px)`
        elementSlideSwrap.style.transitionDuration = `300ms`
      }
    },

    async handleZoom (valScale = null, type = '+') {
      if (valScale) {
        this.scale = valScale
      } else if(type === '+') {
        this.scale = this.scale < 2 ? this.scale + 0.1 : this.scale
      } else {
        this.scale = this.scale > 0 ? this.scale - 0.1 : this.scale
      }
      this.isZoomFile = this.scale !== 1
      // let elems = document.getElementsByClassName('item__img')
      // let elemsLength = elems.length
      // let elementSlideWidth = this.tabActive === 0 ? document.getElementById(`lesson_img`).clientWidth : document.getElementById(`lesson_img_script`).clientWidth
      // let elementSlideHeight = this.tabActive === 0 ? document.getElementById(`lesson_img`).clientHeight : document.getElementById(`lesson_img_script`).clientHeight
      if (this.scale !== 1) {
        this.styleZoom = {
          ...this.styleZoom,
          // width: `${this.scale > 1 ? elementSlideWidth*this.scale : this.widthImgRenderDefault*this.scale}px`,
          width: `${this.widthImgRenderDefault*this.scale}px`,
          'max-width': 'initial',
          'max-height': 'initial'
        }
      } else {
        this.styleZoom = await {
          ...this.styleZoom,
          width: 'auto',
          'max-width': '100%',
          'max-height': `calc(100vh - 230px)`
        }
      }
    },

    // Return width img support zoomIn & zoomOut
    setWidthImgAfterRender () {
      this.widthImgRenderDefault = this.tabActive === 0 ? document.getElementById(`item_1`).clientWidth : document.getElementById(`item_script_1`).clientWidth
    },

    setSpaceSizeForOpenSidebarBox() {
      const self = this
      let bodyBookBox = document.getElementsByClassName('detail-books__tabs')[0];
      let sidebarBox = document.getElementsByClassName('book-viewer__sidebar')[0];
      let widthSidebarBox = sidebarBox.clientWidth;

      if (bodyBookBox) {
        bodyBookBox.style.paddingLeft = 0;
        bodyBookBox.style.paddingRight = `${widthSidebarBox}px`
        // Set again for box img
        self.sizeBoxSlide.width = bodyBookBox.clientWidth - widthSidebarBox
        self.tabActive === 0 && self.resetTransitionSlide(self.sizeBoxSlide.width)
      }
    },

    resetPageWhenOfBoxsTransition() {
      let bodyBookBox = document.getElementsByClassName('detail-books__tabs')[0];
      bodyBookBox.style.paddingLeft = 0;
      bodyBookBox.style.paddingRight = 0;
      // console.log('Resset: ', bodyBookBox.clientWidth)
      this.sizeBoxSlide.width = bodyBookBox.clientWidth;
      this.tabActive === 0 && this.resetTransitionSlide(bodyBookBox.clientWidth);
    },

    resetTransitionSlide(width) {
      // console.log('width transition: ', width, this.pageSettingLessonPlan.page)
      // let bodyBookBox = document.getElementsByClassName('detail-books__tabs')[0].clientWidth;
      let elementSlideSwrap = document.getElementById(`lesson_img_wrap`);
      // Page = 1 => transition = 0
      if (!elementSlideSwrap) {
        return
      }
      this.slideTranslateX = parseInt(this.pageSettingLessonPlan.page - 1) * parseInt(width) * -1;
      elementSlideSwrap.style.transform = `translateX(${this.slideTranslateX}px)`;
      elementSlideSwrap.style.transitionDuration = `300ms`;
    },

    setScrollToPage(page) {
      let targetPage = page || this.pageSettingScript.page;
        let elem = document.getElementById(`item_script_${targetPage}`)
        if(elem) {
          let topPos = elem.offsetTop;
          scrollTo(document.getElementById('script_docs'), topPos, 600)
        }
    },

    handleScrollScript(event) {
      let currentScrollPosition = event.srcElement.scrollTop;
      let itemScript = document.getElementsByClassName('item-script')[0]
      let itemMargin = 25
      let heightItem = itemScript.clientHeight
      // Setting page Curr
      this.pageSettingScript.page = Math.ceil(currentScrollPosition/(heightItem + itemMargin)) || 1
      // Setting pageLoaded
      if (currentScrollPosition > this.scrollPosition && this.lessonBookViewing[this.indexLessonActive].script && this.lessonBookViewing[this.indexLessonActive].script.totalPage >= this.pageSettingScript.pageLoaded) {
        this.lastPageOffsetTop = document.getElementById(`item_script_${this.pageSettingScript.pageLoaded}`).offsetTop
        if(currentScrollPosition + 50 >= this.lastPageOffsetTop) {
          let space2TotalPage = this.lessonBookViewing[this.indexLessonActive].script.totalPage - this.pageSettingScript.pageLoaded
          let setPageLoad = space2TotalPage > this.pageLoading ? this.pageLoading : space2TotalPage
          this.pageSettingScript.pageLoaded += setPageLoad
        }
        this.scrollPosition = currentScrollPosition
      }

    },

    async handleToggleLessonCats() {
      this.openLessonCats = !this.openLessonCats
      this.keySidebarActive = ''

      if (window.innerWidth > 991 && this.openLessonCats) {
        await this.setSpaceSizeForOpenCatBox()
      }
      if (!this.openLessonCats) {
        await this.resetPageWhenOfBoxsTransition()
      }
      // Reset zoom default
      setTimeout(() => {
        this.handleZoom(1, '+')
      }, 800);
      setTimeout(() => {
        this.setWidthImgAfterRender()
      }, 1000);
    },

    setSpaceSizeForOpenCatBox() {
      let self = this;
      let bodyBookBox = document.getElementsByClassName('detail-books__tabs')[0];
      let catBox = document.getElementsByClassName('book-viewer__cats')[0];
      let widthCatBox = catBox.clientWidth;

      bodyBookBox.style.paddingLeft = `${widthCatBox}px`;
      bodyBookBox.style.paddingRight = 0;
      self.sizeBoxSlide.width = bodyBookBox.clientWidth - widthCatBox;
      self.tabActive === 0 && self.resetTransitionSlide(bodyBookBox.clientWidth - widthCatBox)
    }, 

    directPage(page) {
      if(this.tabActive === 0 && this.lessonBookViewing[this.indexLessonActive].lessonPlan) {
        let typeDirect = this.pageSettingLessonPlan.page > page ? '-' : '+';
        let spaceBetweenThisPage = Math.abs(this.pageSettingLessonPlan.page - page);
        this.pageSettingLessonPlan.page = page;
        this.pageSettingLessonPlan.pageLoaded = page === this.lessonBookViewing[this.indexLessonActive].lessonPlan.totalPage || this.lessonBookViewing[this.indexLessonActive].lessonPlan.totalPage - page < 3 ? page : page + 3
        this.setSlideAction(typeDirect, spaceBetweenThisPage);
      } else if (this.lessonBookViewing[this.indexLessonActive].script) {
        this.pageSettingScript.page = page
        this.pageSettingScript.pageLoaded = page === this.lessonBookViewing[this.indexLessonActive].script.totalPage || this.lessonBookViewing[this.indexLessonActive].script.totalPage - page < 3 ? page : page + 3
        // Await render data
        setTimeout(() => {
          this.setScrollToPage(page)
        }, 200);
      }
    },

    changeTab (tab) {
      this.tabActive = tab
      if(tab === 0 && this.lessonBookViewing[this.indexLessonActive].lessonPlan && this.lessonBookViewing[this.indexLessonActive].lessonPlan.totalPage > 0) {
        this.pageSettingLessonPlan.page = 1
        this.pageSettingLessonPlan.pageLoaded = this.pageLoading
        this.slideTranslateX = 0
        document.getElementById(`lesson_img_wrap`).style.transform = `translateX(${this.slideTranslateX})`
      } else if (tab === 1 && this.lessonBookViewing[this.indexLessonActive].script && this.lessonBookViewing[this.indexLessonActive].script.totalPage > 0) {
        this.pageSettingScript.page = 1
        this.pageSettingScript.pageLoaded = this.pageLoading
      }
    },

    handleShareLesson () {
      this.acSetMediaShareInfo({ ...this.lessonBookViewing[this.indexLessonActive], fullLink: window.location.href })
      this.acToggleModalShareMedia(true)
    },

    handleViewInfo (lesson) {
      getLessonInfo(lesson.lessonPlanId).then(res => {
        if (res) {
          this.lessonInfo = res
          this.$bvModal.show(ID_MODAL_EBOOK_LESSON_INFO)
        }
      })
    },

    handleDownload () {
      let pathDoc = ''
      const nameDoc = `${FLE_DOWNLOAD_BEFORE} ${this.lessonBookViewing[this.indexLessonActive].title}`
      if (this.tabActive === 0 && this.lessonBookViewing[this.indexLessonActive].lessonPlan && this.lessonBookViewing[this.indexLessonActive].lessonPlan.path) {
        pathDoc = this.lessonBookViewing[this.indexLessonActive].lessonPlan.path
      } else if (this.tabActive === 1 && this.lessonBookViewing[this.indexLessonActive].script && this.lessonBookViewing[this.indexLessonActive].script.path) {
        pathDoc = this.lessonBookViewing[this.indexLessonActive].script.path
      } else {
        return
      }
      const linkDownload = `${APP_CONFIG.urlPlatformCmsImg}/${pathDoc}`
      this.downloadDocs(linkDownload, nameDoc, true)
    },
  }
}
</script>

<style lang="scss" scoped>
.ebook-lesson {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}
.heightCollapse{
  height: 53px;
}

.detail-books{
  &__head{
    height: 55px;
    border-bottom: 1px solid $color_border_line;
    padding: 0 35px;

    .btn-function{
      .btn-prepare{
        width: 140px;
        margin-right: 18px;
        &:hover{
          opacity: .8;
        }
      }
      .btn-show{
        width: 135px;

        &:hover{
          * {color: $primary_color;}
        }
      }
    }
  }

  &__body, &__tabs {
    height: calc(100vh - 125px);
    overflow: hidden;
  }
  &__footer{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 99;
    height: 70px;
    border-top: 1px solid $color_border_line;
    padding: 0 35px;
    z-index: 12;

    .icon-list{
      height: 15px;
      width: 15px;
      margin-right: 5px;
    }

    .book-viewer__footer__cats{
      margin-right: 7px;
      height: 30px;
      min-width: 140px;
      line-height: 28px;
      i{
        margin-right: 8px;
      }
    }

    .book-viewer__zoom{
      width: 130px;
      overflow: hidden;
      // margin-right: 18px;
      height: 30px;

      .zoom-out, .zoom-in{
        margin-left: 5px;
      }
    }
  }

  // &__tabs {
  //   &__body {
  //     padding: 35px 0;
  //   }
  // }

  &__actions {
    .item {
      margin-left: 15px;
    }
  }
}

.lib-lesson__imgs {
  width: 100%;
  overflow: hidden;

  .item {
    max-height: calc(100vh - 125px);
    &.zoom-in {
      overflow: auto;
    }
  }

  // &--pptx {
  //   max-height: calc(100vh - 230px);
  //   img, .item {
  //     max-height: calc(100vh - 230px);
  //   }

  //   .item {
  //     overflow: auto;
  //   }
  // }
}

.lib-detail__footer {
  .book-viewer__zoom {
    margin: 0;
  }
}

.book-viewer {
  &__sidebar {
    top: 55px;
  }

  &__paging {
      >* {
          &:not(:last-child) {
              margin-right: 12px;
          }
      }
      button,
      &__input { //, &__zoom
          height: $height_btn;
          line-height: 28px;
      }
      button {
          @extend .bg-transparent;
          border: 1px solid transparent;
          @extend .border-rd-20;
          min-width: 30px;
          @extend .text-center;
          &:hover {
            @extend .bg-main-light;
              i,
              i:before {
                  @extend .primary-color;
              }
          }
      }
      &__input {
          width: 100px;
          @extend .border-rd-20;
          @extend .bg-color-light;
          border: 1px solid $color_light;
          overflow: hidden;
          @extend .text-center;
          * {
              @extend .secondary-color-txt;
              @extend .font-size-16;
          }
          &:hover {
              border-color: $primary_color;
          }
          input {
              @extend .border-rd-20;
              &:focus {
                  border: 1px solid $primary_color;
              }
          }
      }
      input {
          @extend .border-0;
          @extend .full-box;
          @extend .text-center;
          &:active,
          &:focus,
          &:visited {
              outline: 0;
          }
      }
      .show-pages--mobile {
          display: none;
      }
      &.has-exercise {
          @media screen and ( max-width: 767px) {
              .book-viewer__paging__input {
                  width: 65px;
                  span {
                      min-width: 100%;
                  }
              }
          }
          @media screen and ( min-width: 360px) and ( max-width: 767px) {
              button {
                  min-width: 45px;
              }
          }
          @media screen and ( max-width: 359px) {
              button {
                  min-width: 37px;
              }
              >* {
                  margin-right: 8px;
              }
          }
      }
      @media screen and ( max-width: 991px) {
          .show-pages {
              display: none;
              &--mobile {
                  display: block;
              }
          }
      }
  }
  &__zoom {
      width: 115px;
      @extend .bg-color-light;
      @extend .border-rd-20;
      @extend .font-size-16;
      @extend .secondary-color-txt;
      @extend .display-flex-center;
      @extend .justify-content-between;
      overflow: hidden;
      margin-right: 18px;
      button {
          @extend .bg-transparent;
          @extend .border-0;
          @extend .secondary-color-txt;
          @extend .font-size-20;
          &.zoom {
              &-out {
                  margin-left: 5px;
              }
              &-in {
                  margin-right: 5px;
              }
          }
          &:active,
          &:focus,
          &:visited {
              outline: 0;
          }
      }
      &__mobile {
          .exercise {
              margin-right: 40px;
              a {
                  &:not(:last-child) {
                      margin-right: 35px;
                  }
              }
              @media screen and ( min-width: 360px) and ( max-width: 575px) {
                  margin-right: 25px;
                  a {
                      &:not(:last-child) {
                          margin-right: 25px;
                      }
                  }
              }
          }
      }
  }
  &__cats {
    position: absolute!important;
    top: 0!important;
    height: 100%!important;
  }
}

#script_docs {
  max-height: calc(100vh - 200px);
  overflow: auto;

  .item {
    margin-bottom: 25px;
    @extend .bg-color-light;
  }
}

@media (min-width: 992px){
  .d-lg-none {
    display: none !important;
  }
}

@media screen and ( max-width: 991px ) {
  .lib-detail__footer {
    .book-viewer__footer__cats {
      min-width: auto;
    }
  }

  .lib-lesson__sidebar {
    &.active, &.active.mobile-open {
      -webkit-transform: translate(0px, 0px);
      transform: translate(0px, 0px);
    }
  }
}

@media screen and (min-width: 768px) and ( max-width: 991px ) {
  .lib-detail__footer {
    
    .book-viewer__zoom {
      width: 115px;
    }
  }
}

@media screen and ( min-width: 576px ) and ( max-width: 991px ) {
  .lib-lesson__sidebar {

    &.mobile-close {
      -webkit-transform: translate(calc(95vw), 0px);
      transform: translate(calc(95vw), 0px);
    }

    &.mobile-open:not(.active) {
      -webkit-transform: translate(calc(75vw), 0px);
      transform: translate(calc(75vw), 0px);
    }
  }
}

@media screen and ( max-width: 767px ) {
  .lib-detail__footer {
    .book-viewer__zoom {
      font-size: 12px;
      margin: 0;

      .ratio-book{
        width: 60px;
        text-align: center;
        font-size: 13px;

      }
      .zoom-in, .zoom-out {
        margin: 0;
      }
    }

    .book-viewer__paging__input {
      width: 75px;
    }

    .book-viewer__paging button {
      min-width: 25px;
      width: 25px;
      height: 25px;
      line-height: 23px;
    }

  }
  .detail-books__footer {
    padding: 0 15px;

    .icon-list {
      margin-right: 0;
    }
  }
}

@media screen and ( min-width: 576px ) and ( max-width: 767px ) {
  .lib-detail__footer {
  
    .book-viewer__paging button {
      min-width: 30px;
    }
  }

  .book-viewer__zoom-switch {
    max-width: 240px;
  }
}

@media screen and ( max-width: 575px ) {
  .lib-lesson__sidebar {
    &.mobile-close {
      -webkit-transform: translate(calc(95vw), 0px);
      transform: translate(calc(95vw), 0px);
    }

    &.mobile-open:not(.active) {
      -webkit-transform: translate(calc(80vw), 0px);
      transform: translate(calc(80vw), 0px);
    }
  }
  .lib-detail__footer {
    .book-viewer__paging {
      > *:not(:last-child) {
        margin-right: 5px;
      }
      button {
        min-width: 25px;
        width: 25px;
        height: 25px;
        line-height: 25px;
        padding: 0;
      }
    }
    .book-viewer__zoom {
      width: 95px;
      
      .zoom-in, .zoom-out {
        margin: 0;
        padding: 0;
        i {
          font-size: 13px;
        }
      }
      .zoom-out {
        padding-left: 5px;
      }
      .zoom-in {
        padding-right: 5px;
      }
    }
  }

  .detail-books {
    &__head {
      display: block;
      height: auto;
      padding: 8px 15px;

      .ebook-lesson__back {
        margin-bottom: 10px;
      }
    }

    &__body {
      padding-top: 10px;
      // height: calc(100vh - 130px);
    }

    &__footer {
      height: 50px;
    }

    .book-viewer__cats {
      z-index: 1;
    }
  }
}
</style>
